import { render, staticRenderFns } from "./FormItemPhoneNumber.vue?vue&type=template&id=4fb08c86"
import script from "./FormItemPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./FormItemPhoneNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports